import { requestWithToken as request } from "./api";

export const uploadFiles = (data = {}) =>
    request.post("/general_file_upload/", data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

export const checkStatusFilesValidation = (kind_file) =>
    request.get(
        `/general_file_upload/validate_status/?kind_file=${kind_file}&format=json`
    );

export const getUrlsFilesHistory = () =>
    request.get(`/general_file_upload/get_urls_files_history/?format=json`);

export const getUrlsDownloadFile = (data = {}) =>
    request.post(
        `/general_file_upload/get_url_download_file/?format=json`,
        data
    );

export const getFilesUsersByCompany = (idCompany) =>
    request.get(
        `/general_file_upload/files_by_users_company/?company_id=${idCompany}&format=json`
    );

export const uploadFileExcel = (data = {}) =>
    request.post("/upload_files_view/upload_new_file/", data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

export const getAllFilesUploadedByYear = (data = {}) =>
    request.post(
        "/upload_files_view/get_spreadsheet_uploaded_by_year/?format=json",
        data
    );

export const getSpreadsheetByMonth = (data = {}) =>
    request.post(
        "/upload_files_view/get_spreadsheet_by_month/?format=json",
        data
    );

export const deleteFileMonth = (idSpreadsheetFile = "") =>
    request.delete(
        `/upload_files_view/${idSpreadsheetFile}/delete_file_spreadsheet/?format=json`
    );
